import React from 'react'
import { SocialAccountCreator } from 'types/social-account'
import userImgPlaceholder from "assets/images/users/user-dummy-img.jpg"
import InstagramLogoIcon from 'assets/icons/InstagramLogoIcon'
import FollowersIcon from 'assets/icons/mono/FollowersIcon'
import { formatNumber } from 'utils/helpers'

interface CreatorCardProps {
    creator: SocialAccountCreator
    showOverlay?: boolean
    onHoverActions?: React.ReactNode
    alwaysVisibleActions?: React.ReactNode
    onClick?: (uuid: string) => void
    isSelected?: boolean
    onToggleSelect?: (creatorId: string) => void
}

const CreatorCard: React.FC<CreatorCardProps> = ({
    creator,
    showOverlay = true,
    onHoverActions,
    alwaysVisibleActions,
    onClick,
    isSelected = false,
    onToggleSelect,
}) => {
    const creatorId = creator.social_account.uuid

    return (
        <div className={`creator-card h-100${isSelected ? ' creator-card--selected' : ''}${onToggleSelect ? ' creator-card--selectable' : ''}`}>
            <div className="creator-card__profile_picture position-relative" onClick={() => {
                onClick?.(creatorId);
            }}>
                <img src={creator?.social_account?.profile_picture_url ?? userImgPlaceholder} alt={creator.social_account.handle} />
                {
                    !!onToggleSelect &&
                    <button
                        type="button"
                        className={`creator-card__select${isSelected ? ' creator-card__select--checked' : ''}`}
                        onClick={(e) => {
                            e.stopPropagation();
                            onToggleSelect(creatorId);
                        }}
                        aria-label={`${isSelected ? 'Deselect' : 'Select'} ${creator.social_account.name}`}
                        aria-pressed={isSelected}
                    >
                        <i className="ri-check-line" aria-hidden />
                    </button>
                }
                {
                    showOverlay &&
                    <div className="masonry-overlay flex-column justify-content-between align-items-start p-2">
                        {
                            !!onHoverActions &&
                            <div className="position-absolute" style={{ right: '8px', top: '8px', left: 'none' }} onClick={(e) => e.stopPropagation()}>
                                {onHoverActions}
                            </div>
                        }
                    </div>
                }
                {
                    !!alwaysVisibleActions &&
                    <div className="creator-card__actions" onClick={(e) => e.stopPropagation()}>
                        {alwaysVisibleActions}
                    </div>
                }
            </div>
            <div className="creator-card__details">
                <div className="creator-card__details-row">
                    <div className="creator-card__info">
                        <span className="creator-card__name" title={creator.social_account.name}>
                            {creator.social_account.name}
                        </span>
                        <span className="creator-card__handle" title={creator.social_account.handle}>
                            <InstagramLogoIcon />
                            <span>{creator.social_account.handle}</span>
                        </span>
                    </div>
                    <div className="creator-card__stats">
                        <span className="creator-card__followers_count">
                            <FollowersIcon /> <span>{formatNumber(creator.social_account.followers_count)}</span>
                        </span>
                        <span className="creator-card__folowers_label">
                            Followers
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreatorCard
